import { call, put, takeLatest } from "redux-saga/effects";

import {
  changePasswordFailure,
  changePasswordSuccess,
  loginFailure,
  loginSuccess,
  refreshTokenFailure,
  refreshTokenSuccess,
  registerFailure,
  registerSuccess,
  requestOtpFailure,
  requestOtpSuccess,
  updatePasswordFailure,
  updatePasswordSuccess,
  verifyOtpFailure,
  verifyOtpSuccess
} from "./authActions";

import CryptoJS from "crypto-js";
import {
  authenticateEffect,
  changePasswordEffect,
  forgotPasswordEffect,
  getAccessToken,
  registerEffect,
  sendOtpEffect,
  setAuthorizationHeader,
  verifyOtpEffect
} from "./authEffect";

import {
  CHANGE_PASSWORD_REQUEST,
  LOGIN_REQUEST,
  REFRESH_TOKEN_REQUEST,
  REGISTER_REQUEST,
  REQUEST_OTP_REQUEST,
  UPDATE_PASSWORD_REQUEST,
  VERIFY_OTP_REQUEST
} from "./authType";

const SECRET_KEY = "843567893696976453275974432697R634976";


//
function* loginSaga(action) {
  try {
    const response = yield call(authenticateEffect, action.payload);

    if (!response || response.status !== 200) {
      throw new Error("Server error occurred");
    }
    const { accessToken, refreshToken, user,message } = response.data;
    if (accessToken && refreshToken && user?.email) {
      setAuthorizationHeader(accessToken, user.email);
      const encryptedAccessToken = CryptoJS.AES.encrypt(
        accessToken,
        SECRET_KEY
      ).toString();
      const encryptedRefreshToken = CryptoJS.AES.encrypt(
        refreshToken,
        SECRET_KEY
      ).toString();
      localStorage.setItem("accessToken", encryptedAccessToken);
      localStorage.setItem("refreshToken", encryptedRefreshToken);
      localStorage.setItem("email", user.email);
      yield put(loginSuccess({
        user,
        accessToken,
        refreshToken,
        message
      }));
    }
  } catch (error) {
    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(loginFailure({ errorMessage: backendMessage }));
  }
}
//Register
function* signupSaga(action) {
  try {
    const response = yield call(registerEffect, action.payload);
    if (response?.status === 200) {
      yield put(registerSuccess({ ...response.data }));
    } else {
      const errorMessage = response.data.body?.error || "Registration failed";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to register user";
    yield put(registerFailure({ errorMessage: message, errorFields }));
  }
}

// Send OTP
function* sendOtpSaga(action) {
  try {
    const response = yield call(sendOtpEffect, action.payload);

    if (response?.status === 200) {
      yield put(requestOtpSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Otp failed to send";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      requestOtpFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}

//Verify Otp
function* verifyOtpSaga(action) {
  try {
    const response = yield call(verifyOtpEffect, action.payload);

    if (response?.status === 200) {
      yield put(verifyOtpSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to verify OTP";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      verifyOtpFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}

//saga Otp
function* refreshTokenSaga(action) {
  try {
    const response = yield call(getAccessToken, action.payload);

    if (response?.status === 200) {
      yield put(refreshTokenSuccess(response.data));
    } else {
      const errorMessage = response?.data?.message || "Failed to verify OTP";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      refreshTokenFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}

function* updatePasswordSaga(action) {
  try {
    const response = yield call(forgotPasswordEffect, action.payload);
    if (response?.status === 200) {
      yield put(updatePasswordSuccess(response.data));
    } else {
      const errorMessage =
        response?.data?.message || "Failed to change password";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      updatePasswordFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}

function* changePasswordSaga(action) {
  try {
    const response = yield call(changePasswordEffect, action.payload);
    if (response?.status === 200) {
      yield put(changePasswordSuccess(response.data));
    } else {
      const errorMessage =
        response?.data?.message || "Failed to update password";
      throw new Error(errorMessage);
    }
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message || "An unexpected error occurred";
    yield put(
      changePasswordFailure({
        errorMessage: message,
        errorFields,
      })
    );
  }
}



export function* AuthSaga() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  yield takeLatest(REGISTER_REQUEST, signupSaga);
  yield takeLatest(REQUEST_OTP_REQUEST, sendOtpSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);
  yield takeLatest(UPDATE_PASSWORD_REQUEST, updatePasswordSaga);
  yield takeLatest(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeLatest(REFRESH_TOKEN_REQUEST, refreshTokenSaga);
}